import React from "react"
import PanelLayoutContent from "components/layout/PanelLayoutContent"
import { Outlet } from "react-router-dom"

const Offers = () => {
  return (
    <>
      <PanelLayoutContent title="Lista ofert" text="Lista ofert na platformie">
        <Outlet />
      </PanelLayoutContent>
    </>
  )
}

export default Offers
